import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useBusinessModelsApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/businessmodels', 'get');
    return { data, loading, error, refetch };
};
